export default __webpack_public_path__ + "static/media/check.ce51f68f.png";